import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
let accessToken = null;
let refreshPromise = null;

export const setAccessToken = (token) => { accessToken = token || null; };
export const clearAccessToken = () => { accessToken = null; };

const api = axios.create({baseURL: API_URL, withCredentials: true});

api.interceptors.request.use((config) => {
    if (!config.headers["Content-Type"] && !(config.data instanceof FormData)) config.headers["Content-Type"] = "application/json";
    if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;
    return config;
});

const refresh = async () => {
    if (!refreshPromise) {
        refreshPromise = axios.post(`${API_URL}/v1/staff/auth/refresh`, {}, {withCredentials: true})
            .then(({data}) => { setAccessToken(data.access_token); return data.user; })
            .finally(() => { refreshPromise = null; });
    }
    return refreshPromise;
};

export const restoreStaffSession = async () => {
    const user = await refresh();
    const {data} = await api.get("/v1/staff/auth/me");
    return data.user || user;
};

api.interceptors.response.use((response) => response, async (error) => {
    const original = error.config || {};
    if (error.response?.status === 401 && !original.url?.includes("/v1/staff/auth/") && !original._retried) {
        original._retried = true;
        try { await refresh(); return api(original); }
        catch (_) { clearAccessToken(); window.dispatchEvent(new Event("staff-session-expired")); }
    }
    return Promise.reject(error);
});

export default api;
